import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.xxlg};
  background-color: ${({ theme }) => theme.colors.background};
  background-image: linear-gradient(
    to top,
    ${({ theme }) => theme.colors.background},
    rgba(250, 250, 250, 0.05)
  );
`;

export const CallList = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const NoCallsContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  > span {
    font-size: 40px;
    color: ${({ theme }) => theme.colors.cardText};
    font-weight: bold;
  }
`;
